<template>
  <section :class="[padded ? 'panel-pad' : 'panel', className]">
    <slot />
  </section>
</template>

<script lang="ts">
export default {
  props: {
    padded: { type: Boolean, default: true },
    className: { type: String, default: "" },
  },
};
</script>
